import React from "react";
import { useFormContext } from "react-hook-form";
import {
    ContentSection,
    createFailure,
    FailureSeverity,
    FormDynamicTextField,
    FormDynamicTextFieldRules,
    Stack,
    validationFailed,
    validationSuccessful
} from "sprint-common-web";

const rules: FormDynamicTextFieldRules = {
    required: false,

    validate: (note: string) => {
        if (note.length > 500)
            return validationFailed([
                createFailure(
                    "Must not exceed 500 characters",
                    "FILE_RECORD_NOTE_LENGTH_EXCEEDED",
                    FailureSeverity.Error
                )
            ]);

        return validationSuccessful();
    }
};

export const CreateFileRecordNotesSection: React.FC = () => {
    const { errors, control, watch } = useFormContext();

    const notes = watch("notes");

    return (
        <ContentSection header="Notes" style={{ height: "39vh", overflow: "hidden" }}>
            <Stack style={{ height: "30vh", overflowY: "auto" }}>
                <FormDynamicTextField
                    control={control}
                    errors={errors}
                    label="Note"
                    name="notes"
                    multiline
                    currentItems={notes}
                    rules={rules}
                />
            </Stack>
        </ContentSection>
    );
};
